import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { Ca1Model } from './../../../models/societe-linked/ca1.model';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { UntypedFormGroup } from '@angular/forms';
import { SiteService } from './../../../services/societe-linked/site.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GestionCa1Component } from './../../../../core/gestion-referentiel/gestion-ca1/gestion-ca1.component';
import { ToastrService } from 'ngx-toastr';
import { Ca1Service } from './../../../services/societe-linked/ca1.service';
import { Router } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';

export interface DialogData {
  form: UntypedFormGroup;
  sites: SiteModel[];
  societeId: number;
  result: boolean;
}
@Component({
  selector: 'app-modal-add-site',
  templateUrl: './modal-add-site.component.html',
  styleUrls: ['./modal-add-site.component.scss']
})
export class ModalAddSiteComponent implements OnInit {

  sites: SiteModel[];
  ca1s: Ca1Model[];
  form: UntypedFormGroup;
  ca1: Ca1Model;
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<GestionCa1Component>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private router: Router
            , private ca1Service: Ca1Service
            , private siteService: SiteService) {

             }

  ngOnInit(): void {
    this.sites = this.data.sites;
    // Ajouter un SeuilModel + gestion des seuils
    this.form = this.data.form;
    // Récuperation des ca1s
    if (this.form.get('id').value && this.form.get('code').value){
      this.ca1Service.getFromSiteAdmin(this.data.societeId, this.form.get('code').value).subscribe(ca1s => {
        this.ca1s = ca1s;
        this.ca1 = ca1s.find(s => s.code === this.data.form.get('ca1').value);
      });
    } else {
      this.ca1Service.getFromSociete(this.data.societeId).subscribe(ca1s => {
        this.ca1s = ca1s;
        this.ca1 = null;
      });
    }
  }


    onModalCancel(): void {
      this.data.result = false;
      this.dialogRef.close(false);
    }

    onModalConfirm(): void {
      if (this.form.valid) {
        const site = this.form.getRawValue();
        this.ca1 ? site.ca1 = this.ca1.code : site.ca1 = '';
        // Création
        if (!this.form.get('id').value){
          const dialogRef = this.dialog.open(SpinnerModalComponent);
            this.siteService.save(site).subscribe((a: SiteModel) => {
              this.toastr.success('', 'Création du site ' + a.code + ' réussie');
              this.dialogRef.close(true);
              dialogRef.close();
              }, (error) => {
                this.dialogRef.close(true);
                dialogRef.close();
            });
        } else { // Modification
          const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.siteService.update(site.id, site).subscribe((a: SiteModel) => {
            this.toastr.success('', 'Modification du site ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
              }, (error) => {
                this.dialogRef.close(true);
                dialogRef.close();
          });
        }
      } else {
        this.displayErrors();
        // this.toastr.warning('', 'Veuillez remplir les champs obligatoire');
      }
   }

   displayErrors(): void {
    for (const index in this.form.controls) {
      if (index && (this.form.controls[index].hasError('required') || this.form.controls[index].hasError('max'))) {
        this.form.controls[index].markAsTouched();
      }
    }
  }

}

